<h2 mat-dialog-title>
  <ui-atom-text
    class="dialog-title"
    [text]="titleKey | translate: data.titleParams || {}"
    type="title"
  >
  </ui-atom-text>
</h2>

<mat-dialog-content>
  <div class="dialog-content-message">
    <ui-atom-text [text]="messageKey | translate: data.messageParams || {}" type="regular">
    </ui-atom-text>
  </div>

  @if (data.checkboxLabelKey) {
    <form [formGroup]="form" class="dialog-confirm-form">
      <mat-checkbox formControlName="confirm" color="warn">
        {{ checkboxKey | translate: data.checkboxLabelParams || {} }}
      </mat-checkbox>
    </form>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-buttons">
  <ui-atom-button
    type="button"
    rules="main"
    styling="outlined"
    [withShadow]="false"
    [text]="cancelKey | translate: data.cancelButtonParams || {}"
    (buttonClick)="cancel()"
  >
  </ui-atom-button>

  <ui-atom-button
    type="button"
    rules="main"
    styling="filled"
    [withShadow]="true"
    [text]="confirmKey | translate: data.confirmButtonParams || {}"
    [disabled]="!form.valid"
    (buttonClick)="submit()"
  >
  </ui-atom-button>
</mat-dialog-actions>
